import { Button, ButtonProps } from "@/components/ui/button";
import { useToastError } from "@/components/ui/use-toast";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamBillingPortalDTO } from "@shaarp/common";
import { useState } from "react";
import { RxExternalLink } from "react-icons/rx";

export const ButtonTeamBillingPortal = ({
  text,
  ...props
}: ButtonProps & { text?: string }) => {
  const toastError = useToastError();
  const api = useApi();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Set default text if not provided
  const buttonText =
    text || t("team.components.billingPortalButton.defaultText");

  const openPortal = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get<TeamBillingPortalDTO>(
        `/my/team/billing/portal`
      );

      if (data && data.url) {
        window.open(data.url, "_blank")?.focus();
      }
    } catch (e) {
      toastError();
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Button {...props} disabled>
        {t("team.components.billingPortalButton.loading")}
      </Button>
    );
  }

  return (
    <Button onClick={openPortal} {...props}>
      <RxExternalLink className="mr-2 w-4 h-4" />
      {buttonText}
    </Button>
  );
};
